import 'navigator.sendbeacon'
import {throttle} from 'lodash'
import cookie from 'cookie'
import {getSafeBlob} from 'powtoon-commons/utils/blob'

import {createLogger} from '../../logging'

const logger = createLogger('html-player', 'eventSender')

const SEND_VIEW_EVENT_DELAY = 5000
const CSRF_TOKEN = cookie.parse(document.cookie)['csrftoken']

let eventsDataToSend = null
let HOST = null
let POWTOON_HASH = null
let VIEW_SESSION_ID = null
const CREATE_SESSION_URL = '{host}/api/v2/views/powtoons/{powtoonHash}/sessions'
const UPDATE_SESSION_URL = '{host}/api/v2/views/powtoons/{powtoonHash}/sessions/{viewSessionId}'

function buildUrl(urlTemplate) {
  return urlTemplate.replace('{host}', HOST)
    .replace('{powtoonHash}', POWTOON_HASH)
    .replace('{viewSessionId}', VIEW_SESSION_ID)
}

const serializeEventData =
  (eventsDataToSend) => typeof eventsDataToSend === 'object' ? JSON.stringify(eventsDataToSend) : eventsDataToSend

const buildRequestData =
  () => Object.keys(eventsDataToSend)
    .map(key => `${key}=${serializeEventData(eventsDataToSend[key])}`)
    .concat(`csrfmiddlewaretoken=${CSRF_TOKEN}`)
    .join('&')

function sendBeacon() {
  if (!VIEW_SESSION_ID) {
    return
  }

  const blob = getSafeBlob([buildRequestData()], {type: 'application/x-www-form-urlencoded'})

  navigator.sendBeacon(buildUrl(UPDATE_SESSION_URL), blob)
  eventsDataToSend = null
}

const throttledSend = throttle(sendBeacon, SEND_VIEW_EVENT_DELAY)

export function sendViewEvent(e, {forceSend}={}) {
  try {
    eventsDataToSend = {
      ...eventsDataToSend,
      ...e
    }
    if (forceSend) {
      throttledSend.cancel()
      sendBeacon()
    }
    else {
      throttledSend()
    }
  } catch (err) {
    logger.error(err)
  }
}

export const createViewSession = async (host, powtoonHash, sessionData) => {
  HOST = host
  POWTOON_HASH = powtoonHash

  const options = {
    method: 'POST',
    credentials: 'include',
    body: JSON.stringify(sessionData),
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': CSRF_TOKEN
    }
  }

  try {
    const response = await fetch(buildUrl(CREATE_SESSION_URL), options)
    if (!response.ok) {
      throw new Error('View-session creation failed')
    }

    const data = await response.json()
    VIEW_SESSION_ID = data.view_session_id
  } catch (err) {
    logger.error(new Error(`View-session creation failed: ${err.message}`))
    return Promise.reject(err)
  }
}
